import { Accordion, AccordionDetails, AccordionSummary, Typography, Box } from "@mui/material"
import React, { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface QuestionItemProps {
  question: string;
  answer: string;
  expanded?: boolean;
}

export interface SectionItemProps {
  title: string;
  content: QuestionItemProps[];
}

const SectionItem: React.FC<SectionItemProps> = ({title, content}) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  }

  return (
    <Accordion
      className="input.standard.enabledBorder"
      expanded={expanded}
      onChange={handleChange}
      sx={{
        width: '100%',
        borderRadius: 1.5,
        border: 'solid 1px',
        borderColor: theme => theme.palette.divider,
        '&::before': {
          display: 'none',
        },
      }}
      elevation={0}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel-${title}-content`}
      >
        <Typography variant="h7">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          gap: 1,
        }}
      >
        {content.map((item, ind) => (
          <QuestionItem
            key={`${item.question}-${ind}`}
            question={item.question}
            answer={item.answer}
            expanded={expanded}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  )
}

const QuestionItem: React.FC<QuestionItemProps> = ({question, answer, expanded}) => {
  if (!expanded) return null;
  
  return (
    <Box
      sx={{
        width: '100%',
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        mb: 1,
        bgcolor: 'background.paper'
      }}
    >
      <Typography variant="h8" sx={{ fontWeight: 'bold', mb: 1 }}>
        {question}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {answer}
      </Typography>
    </Box>
  )
}

export default SectionItem;